// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__36nom","options":"AnswerScale_options__3IqW2","selected":"AnswerScale_selected__3C_IK"};